import React from 'react';
import { Result, Button } from 'antd';
function NotFoundContainer() {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <a href="/dashboard">
          <Button type="primary">Go To Dashboard</Button>
        </a>
      }
    />
  );
}

export default NotFoundContainer;
